import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Brands } from "../../end-customer/brands.entity";
import { FoodType } from "../../food-types/food-types.entitiy";
import { ItemCategory } from "../../item-categories/item-categories.entity";
import { ItemSubCategory } from "../../item-sub-categories/item-sub-category.entity";
import { MasterBrand } from "../../master-brands/master-brands.entity";
import { Product } from "../../products/product.entity";
import { Sizes } from "../../sizes/sizes-entity";
import { SkuCodes } from "../../sku-codes/sku-codes.entity";
import { Uoms } from "../../uoms/uom.entity";
import { ValueAdditionOneType } from "../../value-addition1-types/value-addition-one.entity";
import { ValueAdditionTwoType } from "../../value-addition2-types/value-addition-two.entity";
import { ValueAdditionThreeType } from "../../value-addition3-types/value-addition-three.entity";
import { ValueAdditionFourType } from "../../value-addition4-types/value-addition-four.entity";
import { ValueAdditionFiveType } from "../../value-addition5-types/value-addition-five.entity";
import { Item } from "../item.entity";
import { ItemDto } from "./item.dto";

export class ItemAdapter {
    convertDtoToEntity(dtoObj: ItemDto, isUpdate: boolean = false): Item {
        console.log(dtoObj,'dtoObjlll')
        const entityObj = new Item();
        entityObj.createdUser = dtoObj.createdUser;
        entityObj.itemCode = dtoObj.itemCode;
        entityObj.itemCategoryInfo = new ItemCategory();
        entityObj.itemCategoryInfo.itemCategoryId = dtoObj.itemCategoryId
        entityObj.itemSubCategory = new ItemSubCategory();
        entityObj.itemSubCategory.itemSubCategoryId = dtoObj.itemSubCategoryId
        entityObj.itemName = dtoObj.itemName;
        entityObj.productCode = dtoObj.productCode;
        entityObj.productInfo = new Product();
        entityObj.productInfo.productId = dtoObj.productId;
        entityObj.sizeInfo = new Sizes();
        entityObj.sizeInfo.sizeId = dtoObj.sizeId;
        entityObj.count = dtoObj.count;
        if(dtoObj.isAsset == 'YES'){
            entityObj.isAsset = GlobalStatus.YES;
            // entityObj.assetSla = dtoObj.assetSla;
            // entityObj.assetPriority = dtoObj.assetPriority;
        }else{
            entityObj.isAsset = GlobalStatus.NO;
        }
        
        if (dtoObj.packingCategory) {
            entityObj.packingCategory = dtoObj.packingCategory;
            entityObj.brandsInfo = new MasterBrand();
            entityObj.brandsInfo.masterBrandId = dtoObj.brandId;
            entityObj.skuInfo = new SkuCodes();
            entityObj.skuInfo.skuCodeId = dtoObj.varientId;
            entityObj.minGrade = dtoObj.minGrade;
            entityObj.maxGrade = dtoObj.maxGrade;
            entityObj.bapNo = dtoObj.bapNo;
            entityObj.pouches = dtoObj.pouches;
            entityObj.pouchWeight = dtoObj.pouchWeight;
            entityObj.uomInfo = new Uoms();
            entityObj.uomInfo.uomId = dtoObj.uomId;
            entityObj.foodTypeInfo = new FoodType();
            entityObj.foodTypeInfo.foodTypeId = dtoObj?.foodTypeId;
            entityObj.valueAdditionOneTypeInfo = new ValueAdditionOneType();
            entityObj.valueAdditionOneTypeInfo.valueAdditionOneId = dtoObj?.valueAdditionOneId;
            entityObj.valueAdditionTwoTypeInfo = new ValueAdditionTwoType();
            entityObj.valueAdditionTwoTypeInfo.valueAdditionTwoId = dtoObj?.valueAdditionTwoId;
            entityObj.valueAdditionThreeTypeInfo = new ValueAdditionThreeType();
            entityObj.valueAdditionThreeTypeInfo.valueAdditionThreeId = dtoObj?.valueAdditionThreeId;
            entityObj.valueAdditionFourTypeInfo = new ValueAdditionFourType();
            entityObj.valueAdditionFourTypeInfo.valueAdditionFourId = dtoObj?.valueAdditionFourId;
            entityObj.valueAdditionFiveTypeInfo = new ValueAdditionFiveType();
            entityObj.valueAdditionFiveTypeInfo.valueAdditionFiveId = dtoObj?.valueAdditionFiveId;
            entityObj.approvalNo = dtoObj.approvalNo;
            entityObj.type = dtoObj.type;
            entityObj.netWeight = dtoObj.netWeight;
        }

        entityObj.minimumQuantity = dtoObj.minimumQuantity;
        entityObj.remarks = dtoObj.remarks;
        if (dtoObj.itemId) {
            entityObj.itemId = dtoObj.itemId;
            entityObj.updatedUser = dtoObj.updatedUser;
        }
        entityObj.isActive = dtoObj.isActive;
        entityObj.assetType = dtoObj.assetType;
        entityObj.assetSla = dtoObj.assetSla;
        entityObj.assetPriority = dtoObj.assetPriority;
        return entityObj;
    }

    public convertEntityToDto(itemObject: Item): ItemDto {
        const itemsDto = new ItemDto;
        itemsDto.itemId = itemObject.itemId;
        itemsDto.itemCode = itemObject.itemCode;
        if (itemObject.productInfo) {
            itemsDto.productId = itemObject.productInfo.productId;
        } else {
            itemsDto.productId = null;
        }
        itemsDto.count = itemObject.count;
        itemsDto.itemName = itemObject.itemName;
        itemsDto.itemCategoryId = itemObject.itemCategoryInfo.itemCategoryId;
        itemsDto.itemSubCategoryId = itemObject.itemSubCategory.itemSubCategoryId;
        itemsDto.itemSubCategoryName = itemObject.itemSubCategory.itemSubCategory;
        itemsDto.itemCategoryName = itemObject.itemCategoryInfo.itemCategory;
        itemsDto.productCode = itemObject.productCode;
        itemsDto.packingCategory = itemObject.packingCategory;
        itemsDto.bapNo = (itemObject.bapNo ) ? itemObject.bapNo: null;
        itemsDto.brandId = (itemObject.brandsInfo) ? itemObject.brandsInfo.masterBrandId : null;
        itemsDto.brandName = (itemObject.brandsInfo) ? itemObject.brandsInfo.masterBrandName : null;
        itemsDto.varientId = (itemObject.skuInfo) ? itemObject.skuInfo.skuCodeId : null;
        itemsDto.varientName = (itemObject.skuInfo) ? itemObject.skuInfo.variantCode : null;
        itemsDto.minGrade = itemObject.minGrade;
        itemsDto.maxGrade = itemObject.maxGrade;
        itemsDto.pouches = itemObject.pouches;
        itemsDto.pouchWeight = itemObject.pouchWeight;
        itemsDto.sizeId = (itemObject.sizeInfo) ? itemObject.sizeInfo.sizeId : null;
        itemsDto.sizeName = (itemObject.sizeInfo) ? itemObject.sizeInfo.sizeName : null;
        itemsDto.uomId = (itemObject.uomInfo) ? itemObject.uomInfo.uomId : null;
        itemsDto.uom = (itemObject.uomInfo) ? itemObject.uomInfo.uomName : null;
        itemsDto.foodTypeId = (itemObject.foodTypeInfo) ? itemObject.foodTypeInfo.foodTypeId : null;
        itemsDto.valueAdditionOneId = (itemObject.valueAdditionOneTypeInfo) ? itemObject.valueAdditionOneTypeInfo.valueAdditionOneId : null;
        itemsDto.valueAdditionTwoId = (itemObject.valueAdditionTwoTypeInfo) ? itemObject.valueAdditionTwoTypeInfo.valueAdditionTwoId : null;
        itemsDto.valueAdditionThreeId = (itemObject.valueAdditionThreeTypeInfo) ? itemObject.valueAdditionThreeTypeInfo.valueAdditionThreeId : null;
        itemsDto.valueAdditionFourId = (itemObject.valueAdditionFourTypeInfo) ? itemObject.valueAdditionFourTypeInfo.valueAdditionFourId : null;
        itemsDto.valueAdditionFiveId = (itemObject.valueAdditionFiveTypeInfo) ? itemObject.valueAdditionFiveTypeInfo.valueAdditionFiveId : null;

        itemsDto.minimumQuantity = itemObject.minimumQuantity;
        itemsDto.remarks = itemObject.remarks;
        itemsDto.isActive = itemObject.isActive;
        itemsDto.createdAt = itemObject.createdAt;
        itemsDto.updatedAt = itemObject.updatedAt;
        itemsDto.createdUser = itemObject.createdUser;
        itemsDto.updatedUser = itemObject.updatedUser;
        itemsDto.versionFlag = itemObject.versionFlag;
        itemsDto.assetType = itemObject.assetType;
        itemsDto.isAsset = itemObject.isAsset;
        itemsDto.assetSla = itemObject.assetSla;
        itemsDto.assetPriority =itemObject.assetPriority;
        return itemsDto;
    }
}